import React, { useEffect, useState } from "react"
import { ActivityIndicator, ScrollView, StatusBar, Text, TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Checkbox } from "react-native-paper"
import { useConsentHooks } from "../../../Hooks/useConsentHooks"
import { useNavigation } from "@react-navigation/native"
import { Spacer } from "@Components/Space"
import { ConsentItems } from "@Constants/constant"
import NoticeConsentItem from "./NoticeConsentItem"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { SwitchContent } from "@Components/CustomCheckBox/CustomCheckBox"

const NoticeConsent = ({}) => {
    const navigation = useNavigation()
    const [payload, setPayload] = useState({
        statistics: null,
        services: null,
        communication: null,
        cgu: null,
        major: null,
        participateInStudy: null
    })

    const handleCheckCondition = (value) => setPayload((prev) => ({ ...prev, participateInStudy: value }))
    const canSubmit = payload.participateInStudy !== null

    function RedirectionHandler(hasConsent) {
        if (hasConsent) {
            navigation.navigate("DiagnosticEducatifList")
        }
    }

    const {
        handleFetchConsent,
        fetchingPatientConsent,
        patientConsent,

        performSaveNoticeConsent,
        saving
    } = useConsentHooks()

    useEffect(() => {
        handleFetchConsent()
    }, [])

    useEffect(() => {
        if (patientConsent) {
            setPayload({
                statistics: patientConsent?.anonymiseMyData ?? null,
                services: patientConsent?.appServices ?? null,
                communication: patientConsent?.commercialOffer ?? null,
                cgu: patientConsent?.condition ?? null,
                major: patientConsent?.isUserMajor ?? null,
                participateInStudy: patientConsent?.participateInStudy ?? null
            })
        }
    }, [patientConsent])

    LocalStorage.getConsentStatus()
        .then((currentNoticeConstentStatus) => {
            const hasConsent = Boolean(currentNoticeConstentStatus?.participateInStudy)
            console.log({ currentNoticeConstentStatus, hasConsent })
            RedirectionHandler(hasConsent)
        })
        .catch(() => {
            console.log({ errorGetingNoticeStatusConstent: "errorGetingNoticeStatusConstent" })
        })

    return (
        <View style={[styles.container, {}]}>
            <ScrollView
                keyboardShouldPersistTaps={"handled"}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 100 }}
            >
                <View style={styles.content}>
                    {fetchingPatientConsent ? (
                        <View style={{ flex: 1, justifyContent: "center", alignContent: "center" }}>
                            <ActivityIndicator color={baseColors.green.primary} size="large" style={{ padding: 20 }} />
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansRegular}
                                style={{ textAlign: "center" }}
                                fontSize={16}
                            >
                                Chargement des données en cours...
                            </OpenSansText>
                        </View>
                    ) : (
                        <>
                            <View style={styles.header}>
                                <BreeSerifText style={styles.title}>Notice d'information des patients</BreeSerifText>

                                <Spacer />

                                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={12}>
                                    <OpenSansText
                                        defaultFontFamily={baseFontFamily.OpenSansRegular}
                                        style={{ fontStyle: "italic" }}
                                        fontSize={13}
                                    >
                                        Intitulé de la structure
                                    </OpenSansText>{" "}
                                    : CERPOP UMR 1295 Inserm UPS - Equipe EQUITY et Département Universitaire de
                                    Médecine générale de Toulouse
                                </OpenSansText>

                                <Spacer />

                                {ConsentItems?.map((consent) => (
                                    <NoticeConsentItem
                                        key={consent.id}
                                        label={consent.label}
                                        value={consent.value}
                                        subContent={consent?.subContent}
                                    />
                                ))}

                                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={12}>
                                    Vous êtes invité(e) à participer à une étude menée par Dr Florent PORTET dans le
                                    cadre de son mémoire de Master 2 de recherche. Cette note d’information résume les
                                    modalités prévues par le code de la santé publique et l’article 6 du RGPD (règlement
                                    général sur la protection des données) concernant la licéité du traitement des
                                    données personnelles, pour s’assurer de votre non-opposition à participer à cette
                                    étude le jour de l’entretien. La base légale de ce traitement est l’exécution d’une
                                    mission d’intérêt public (recherche scientifique). Je vous prie de bien vouloir
                                    prendre connaissance de l’ensemble des informations figurant ci-dessous :
                                </OpenSansText>
                            </View>

                            <Spacer />

                            <View style={styles.header}>
                                <BreeSerifText style={styles.modalite}>Modalités de consentement</BreeSerifText>
                                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={12}>
                                    <OpenSansText
                                        defaultFontFamily={baseFontFamily.OpenSansRegular}
                                        style={{ fontStyle: "italic" }}
                                        fontSize={13}
                                    >
                                        Acceptation
                                    </OpenSansText>{" "}
                                    : En choisissant la phrase ci-dessous, je consens ou ne consens pas à participer à
                                    cette
                                </OpenSansText>
                            </View>

                            <TouchableOpacity
                                onPress={() => handleCheckCondition(true)}
                                style={styles.firstCheckBoxContent}
                            >
                                <SwitchContent
                                    status={payload.participateInStudy === true}
                                    onPress={() => handleCheckCondition(true)}
                                    color={baseColors.orange.primary}
                                    // disabled={fetching}
                                />

                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={12}
                                    style={styles.checkBoxLabel}
                                >
                                    Oui, je veux participer.
                                </OpenSansText>
                            </TouchableOpacity>

                            <TouchableOpacity
                                onPress={() => handleCheckCondition(false)}
                                style={styles.secondCheckBoxContent}
                            >
                                <SwitchContent
                                    status={payload.participateInStudy === false}
                                    onPress={() => handleCheckCondition(false)}
                                    color={baseColors.green.primary}
                                    // disabled={fetching}
                                />
                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={12}
                                    style={styles.checkBoxLabelGreen}
                                >
                                    Non, je ne veux pas participer
                                </OpenSansText>
                            </TouchableOpacity>
                        </>
                    )}
                </View>
            </ScrollView>

            {!fetchingPatientConsent && (
                <Button
                    marginTop={5}
                    loading={saving}
                    onPress={() => performSaveNoticeConsent({ payload })}
                    text="valider"
                    width="60%"
                    disabled={!canSubmit || saving}
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />
            )}
        </View>
    )
}

export default NoticeConsent
